<table id="rwd-table" *ngIf="this.screenWidth > this.minWidth">
  <thead>
    <tr>
      <th *ngFor="let header of this.headerItems">{{header.title}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of this.data">
      <td *ngFor="let header of this.headerItems">{{item[header.objectKey]}}</td>
    </tr>
  </tbody>
</table>

<div *ngIf="this.screenWidth < this.minWidth">
  <mat-accordion class="mat-elevation-z0">
    <mat-expansion-panel  *ngFor="let item of this.data; let index = index">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{getMobileHeader(index)}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row" *ngFor="let header of this.headerItems">
        <div class="col mobile-row-item">
          <b>{{header.title}}</b>
        </div>
        <div class="col">
          {{item[header.objectKey]}}
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>